<template>
    <div class="row single">
				<div class="det">
				  <div class="single_left">
                  
					<div class="grid images_3_of_2">
						<div class="flexslider">
						<div class="thumb-image"> <img :src="this.awardeeProfileImage"  data-imagezoom="true" class="img-responsive" draggable="false"> </div></div>
				 		
								
				  </div>
                  
				  <div class="desc1 span_3_of_2">
					<h2 style="color: orange;"><strong> {{this.Honour}} AWARD FOR YEAR {{this.awardYear}} </strong></h2>
					<br>
					<h4 style="color: orange;"> <strong> CATEGORY: </strong><span style="color: black;">{{this.awardCategory}}</span></h4>
					<br>
					<h4 style="color: orange;"><strong> AWARD CONTEXT: </strong> <span style="color: black;">{{this.context}}</span></h4>
					<br>
					<h4 style="color: orange;"><strong> WON BY: </strong><span style="color: black;">{{this.awardName}}</span></h4>
					
				
					<span class="brand"><strong>BIRTH YEAR: </strong><a href="#">{{this.awardeeBirthYear}}</a> </span>
					<br>
					<span class="brand"><strong>DEATH YEAR : </strong> <a href="#">{{this.awardeeDeathYear}}</a> </span>
					<br>
					<span class="brand"><strong>Country of Origin: </strong><a href="#">{{this.awardeeCountry}}</a></span>
					<br>
					
								
					<div class="btn_form" v-if="showButtonsChecker">
						<a @click="change($event)" href="">UPDATE</a>
					</div>
					<div class="btn_form" v-if="showButtonsChecker">
						<a @click="flush($event)" href="">DELETE</a>
					</div>
				
					
			   	 </div>
          	    <div class="clearfix"></div>
          	   </div>
          	    <div class="single-bottom1">
					<h6 style="color: orange;"><strong>BIOGRAPHY OF {{this.awardName}} : {{this.awardeeTitle}}</strong></h6>
					<p class="prod-desc">{{this.biography}}</p>
				</div>
			
	       </div>		
	  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'profileView',
  props: {
    Id: {
     type: String,
    required: true
  }
},
data()
{
    return {
         userID: null,
		 awardYear:null,
        awardName:null,
        Honour:null,
        awardeeCountry:null,
        awardCategory:null,
        awardeeTitle:null,
        context:null,
        biography:null,
        awardeeBirthYear:null,
        awardeeDeathYear:null,
        awardeeProfileImage:null,
        urlData: null,
		profileDetails:[],
		showButtonsChecker: false
       
    }
},
async mounted()
{
    this.userID = this.Id;
    //make axios graphql query to obtain profile details
	      try{
                    let token = localStorage.getItem("token");
    //https://time-person-mofe.herokuapp.com/
                    let graphResponse = await axios.post("https://time-person-mofe.herokuapp.com/graphql",
                    {
                       query:`
                      {
					FullProfileResult(profileId: "${this.userID}")
					{
						awardYear
						awardName
						honour
						awardeeCountry
						awardCategory
						awardeeProfileImage
						awardeeTitle
						profileId
						context
						biography
						awardeeBirthYear
						awardeeDeathYear
						view
						status
					}
					}
					   `
					   },
					   {"Authorization": "Bearer "+token});

					//process response
                         
                         if(graphResponse.data.data.FullProfileResult.status == "success")
                         {
                         this.awardYear = graphResponse.data.data.FullProfileResult.awardYear;
                         this.awardName = graphResponse.data.data.FullProfileResult.awardName;
                         this.Honour = graphResponse.data.data.FullProfileResult.honour;
                         this.awardeeCountry = graphResponse.data.data.FullProfileResult.awardeeCountry;
                         this.awardCategory = graphResponse.data.data.FullProfileResult.awardCategory;
                         this.awardeeProfileImage = graphResponse.data.data.FullProfileResult.awardeeProfileImage;
                         this.awardeeTitle = graphResponse.data.data.FullProfileResult.awardeeTitle;
                         this.context = graphResponse.data.data.FullProfileResult.context;
                         this.biography = graphResponse.data.data.FullProfileResult.biography;
                         this.awardeeBirthYear = graphResponse.data.data.FullProfileResult.awardeeBirthYear;
						 this.awardeeDeathYear = graphResponse.data.data.FullProfileResult.awardeeDeathYear;
						 
						 this.profileDetails = graphResponse.data;
						 ///alert(this.awardeeProfileImage);
                         }

                         
               //v-model="awardeeProfileImage"
                   //alert(JSON.stringify(graphResponse.data));

            }
            catch(error)
            {
                 alert("User profile data not fetched please refresh "+error.message);
			}
			




			//fire code to verify user and show delete and update buttons
			try
			{
			//get user access token
			let token = localStorage.getItem("token");
			
			if((token == "noToken") || (token == null))
			{
			this.showButtonsChecker = false;
			
			}
			else{
				let userDataResponse = await axios({
			method: "get",
			url: "https://time-person-mofe.herokuapp.com/api/dashboard/profile",
			headers: {"Authorization": "Bearer "+token}
			});

			let requestStatus = userDataResponse.data.status;

			if(requestStatus == "success")
			{
			this.showButtonsChecker = true;
			
			}

			}
			
		}
		catch(error)
		{
		this.showButtonsChecker = false;
		}
		
    
},
methods:
{
    flush: function(e)
    {
		e.preventDefault();
		this.$router.push(`/timeawards/delete/profile/${this.userID}`);
	},
	change: function(e)
    {
		e.preventDefault();
		this.$router.push(`/timeawards/updateProfile/${this.userID}`);
    }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
